export default __webpack_public_path__ + "static/media/tc.45a2dab3.png";